import React from 'react';
import { FIELDS, RentalIncome } from 'modules/cm/domain/Case/Applicant/Income/Current/Current';
import { FormFields } from 'modules/cm/form/Applicant/CurrentIncome';
import { INPUTS } from 'modules/cm/fields/types';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { IncomeFieldsProps } from 'modules/cm/pages/CaseDetailsPage/subPages/Applicant/Income/Current/incomeFields/types';
import UpdatableField from 'modules/cm/fields/UpdatableField';

const RentalIncomeFields: React.FC<IncomeFieldsProps<RentalIncome>> = ({ getErrors, incomes }) => {
  return (
    <>
      {incomes.map((rentalIncome, index) => {
        const rentalIncomeFields = FormFields[FIELDS.RENTAL_PREFIX](index);

        return (
          <React.Fragment key={`RentalIncomeField.${index}`}>
            <UpdatableField
              fieldType={INPUTS.TEXT}
              variant={VARIANTS_TYPES.CURRENCY}
              field={rentalIncomeFields[FIELDS.RENTAL_GROSS_ANNUAL_RENTAL_INCOME]}
              getErrors={getErrors}
            />
            <UpdatableField
              fieldType={INPUTS.TEXT}
              variant={VARIANTS_TYPES.NUMBER}
              field={rentalIncomeFields[FIELDS.RENTAL_NO_OF_BTLS_IN_PORTFOLIO]}
              getErrors={getErrors}
            />
            <UpdatableField
              fieldType={INPUTS.TEXT}
              variant={VARIANTS_TYPES.CURRENCY}
              field={rentalIncomeFields[FIELDS.RENTAL_MORTGAGE_PAYMENT]}
              getErrors={getErrors}
            />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default RentalIncomeFields;
